import * as signalR from "@microsoft/signalr";

let connection = null;

export function getConnection() {
	if (!connection) {
		connection = new signalR.HubConnectionBuilder()
			.withUrl(window.env.signalRHubUrl, {
				transport: signalR.HttpTransportType.WebSockets,
				withCredentials: true
			})
			.withAutomaticReconnect()
			.configureLogging(signalR.LogLevel.Information)
			.build();
	}

	return connection;
}